import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
export var EssayAnswerValue = /*#__PURE__*/function (_ValueObject) {
  _inherits(EssayAnswerValue, _ValueObject);

  var _super = _createSuper(EssayAnswerValue);

  function EssayAnswerValue() {
    _classCallCheck(this, EssayAnswerValue);

    return _super.apply(this, arguments);
  }

  _createClass(EssayAnswerValue, [{
    key: "text",
    get: function get() {
      return this.props.text;
    }
  }, {
    key: "files",
    get: function get() {
      return this.props.files;
    }
  }, {
    key: "audioFile",
    get: function get() {
      return this.props.audioFile;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      var _this$props$audioFile;

      return _objectSpread(_objectSpread({}, this.props), {}, {
        audioFile: (_this$props$audioFile = this.props.audioFile) === null || _this$props$audioFile === void 0 ? void 0 : _this$props$audioFile.toJsonObject()
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var _props$text, _props$files;

      var defaultProps = {
        text: (_props$text = props.text) !== null && _props$text !== void 0 ? _props$text : '',
        files: (_props$files = props.files) !== null && _props$files !== void 0 ? _props$files : [],
        audioFile: props.audioFile
      };
      return Result.ok(new EssayAnswerValue(defaultProps));
    }
  }]);

  return EssayAnswerValue;
}(ValueObject);